module.exports = __webpack_public_path__ + "static/media/padlock.9e5c5714.png";